"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openingPrincipleCodeToKetteOpeningPrinciple = exports.mapIproOeffnungsPrinzipToAkeneoOpeningPrinciple = exports.mapKetteOeffnungsausrichtungToKetteOpeningPrinciple = exports.getAvailableOpeningPrinciples = exports.KetteOpeningPrinciple = void 0;
/**
 * Defines from which side a Kette can be opened for assembly.
 *
 */
const KetteOeffnungsausrichtung_1 = require("./KetteOeffnungsausrichtung");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var KetteOpeningPrinciple;
(function (KetteOpeningPrinciple) {
    KetteOpeningPrinciple["InnerRadius"] = "InnerRadius";
    KetteOpeningPrinciple["OuterRadius"] = "OuterRadius";
    KetteOpeningPrinciple["InnerAndOuterRadius"] = "InnerAndOuterRadius";
    KetteOpeningPrinciple["Closed"] = "Closed";
})(KetteOpeningPrinciple = exports.KetteOpeningPrinciple || (exports.KetteOpeningPrinciple = {}));
const getAvailableOpeningPrinciples = () => {
    return [
        KetteOpeningPrinciple.InnerRadius,
        KetteOpeningPrinciple.OuterRadius,
        KetteOpeningPrinciple.InnerAndOuterRadius,
        KetteOpeningPrinciple.Closed,
    ];
};
exports.getAvailableOpeningPrinciples = getAvailableOpeningPrinciples;
// map KetteOeffnungsausrichtung to KetteOpeningPrinciple
const mapKetteOeffnungsausrichtungToKetteOpeningPrinciple = (ketteOeffnungsausrichtung) => {
    switch (ketteOeffnungsausrichtung) {
        case KetteOeffnungsausrichtung_1.KetteOeffnungsausrichtung.Innen:
            return KetteOpeningPrinciple.InnerRadius;
        case KetteOeffnungsausrichtung_1.KetteOeffnungsausrichtung.Aussen:
            return KetteOpeningPrinciple.OuterRadius;
        case KetteOeffnungsausrichtung_1.KetteOeffnungsausrichtung.Beidseitig:
            return KetteOpeningPrinciple.InnerAndOuterRadius;
        case KetteOeffnungsausrichtung_1.KetteOeffnungsausrichtung.Geschlossen:
            return KetteOpeningPrinciple.Closed;
        default:
            (0, echain_shared_ts_utils_1.assertUnreachable)(ketteOeffnungsausrichtung);
    }
};
exports.mapKetteOeffnungsausrichtungToKetteOpeningPrinciple = mapKetteOeffnungsausrichtungToKetteOpeningPrinciple;
// maps the old iPro Oeffnungsprinzip value to the new akeneo openingPrincipleCode one
const mapIproOeffnungsPrinzipToAkeneoOpeningPrinciple = (iProOeffnungsprinzip) => {
    switch (iProOeffnungsprinzip) {
        // not openable
        case 2:
        case 3:
        case 7:
        case 8:
        case 35:
            return 'closed';
        // openable in inner radius
        case 5:
        case 11:
        case 34:
            return 'openable_from_inner_radius';
        // openable in outer radius
        case 1:
        case 4:
        case 10:
        case 14:
            return 'openable_from_outer_radius';
        case 33:
            return 'open_both_sides_outer_radius';
        // openable from inner and outer radius
        case 9:
        case 15:
        case 16:
            return 'open_inner_and_outer_radius';
        // openable from both sides, lids can be hinge-opened
        case 17:
            return 'openable_from_both_sides_lids_can_be_hinge_opened';
        // fillable from inner and  outer radius
        case 30:
            return 'easy_to_fill_from_both_sides';
        // fillable from outer radius
        case 31:
            return 'to_fill_from_outer_radius';
        // tearable in outer radius
        case 32:
            return 'zip_open';
        // autoglide
        case 18:
            return 'autoglide';
        // Easy Prinzip
        case 36:
            return 'easy_principle';
        // Light-Version Easy Prinzip
        case 37:
            return 'light_version_easy_principle';
        // RX-Deckel
        case 38:
            return 'rx_lid';
        default:
            throw new Error(`mapIproOeffnungsPrinzipToAkeneoOpeningPrinciple() unknown Oeffnungsprinzip ${iProOeffnungsprinzip}`);
    }
};
exports.mapIproOeffnungsPrinzipToAkeneoOpeningPrinciple = mapIproOeffnungsPrinzipToAkeneoOpeningPrinciple;
const openingPrincipleCodeToKetteOpeningPrinciple = (code) => {
    if (!code)
        return;
    // InnerRadius
    if ([
        'openable_from_inner_radius',
        'open_both_sides_inner_radius',
        'open_both_sides_inner_radius_closed_outer_radius',
        'open_both_sides_inner_radius_fully_closed',
    ].includes(code)) {
        return KetteOpeningPrinciple.InnerRadius;
    }
    // OuterRadius
    if ([
        'autoglide',
        'open_both_sides_outer_radius',
        'openable_from_outer_radius',
        'open_one_side_outer_radius',
        'rx_lid',
        'to_fill_from_outer_radius',
        'zip_open',
    ].includes(code)) {
        return KetteOpeningPrinciple.OuterRadius;
    }
    // InnerAndOuterRadius
    if ([
        'easy_principle',
        'easy_to_fill_from_both_sides',
        'light_version_easy_principle',
        'open_inner_and_outer_radius',
        'openable_from_both_sides',
        'openable_from_both_sides_lids_can_be_hinge_opened',
    ].includes(code)) {
        return KetteOpeningPrinciple.InnerAndOuterRadius;
    }
    // Closed
    if (['closed'].includes(code)) {
        return KetteOpeningPrinciple.Closed;
    }
    // unhandled code
    throw new Error(`openingPrincipleCodeToKetteOpeningPrinciple code (${code}) unknown`);
};
exports.openingPrincipleCodeToKetteOpeningPrinciple = openingPrincipleCodeToKetteOpeningPrinciple;
//# sourceMappingURL=KetteOpeningPrinciple.js.map